import { render, staticRenderFns } from "./AuditLogsPage.vue?vue&type=template&id=b8ddea50&scoped=true"
import script from "./AuditLogsPage.vue?vue&type=script&lang=js"
export * from "./AuditLogsPage.vue?vue&type=script&lang=js"
import style0 from "./AuditLogsPage.vue?vue&type=style&index=0&id=b8ddea50&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8ddea50",
  null
  
)

export default component.exports